// extracted by mini-css-extract-plugin
export default {"lineDescription":"kEUbg","border":"_3PY-Y","emptyBlock":"_3lLhg"};